/**
 * Class representing an matrix row for a question.
 */
export class MatrixRow {
    /**
     * Create a matrix row for a question.
     * @param {Object} matrixRow - The question answer
     * @param {Number} matrixRow.matrixRowId - The matrix row id.
     * @param {string} matrixRow.text - The text for the alternative.
     * @param {Number} matrixRow.orderNo - Determines sequence for the alternatives, starting from the lowest.
     * @param {boolean} matrixRow.isDeleted - true if the alternative should be deleted.
     */
    constructor(matrixRow) {
        this.matrixRowId = matrixRow.matrixRowId;
        this.text = matrixRow.text;
        this.orderNo = matrixRow.orderNo;
        this.isDeleted = matrixRow.isDeleted;
    }
}
